import React, {HTMLAttributes} from 'react'
import {Button} from './Button'
import {KTSVG} from './KTSVG'

interface Props extends HTMLAttributes<HTMLButtonElement> {
 icon?: React.ReactNode
 text?: string
 containerClass?: string
 type?: 'button' | 'submit' | 'reset' | undefined
 disabled?: boolean
 filterCount: number
 children?: React.ReactNode
}
const KTFilterButton = (props: Props) => {
 return (
  <>
   <div
    className={`${props?.containerClass} flex items-center`}
   >
    <Button
     disabled={false}
     onClick={props.onClick}
     color='white'
     className='text-center py-[9px] p-3 bg-white 
                              !rounded-lg text-sm !text-[#4E83E4] font-semibold border-[#E6EBF0]'
    >
     <KTSVG
      path={`/media/icons/filter.svg`}
      svgClassName={`${
       props.text && 'mr-2'
      } w-4 h-4 text-white`}
     />
     {props.text}
     {props.filterCount > 0 && (
      <span
       className='absolute -right-2.5 -top-2.5 rounded-full w-5 h-5 flex items-center justify-center bg-[#E05109] 
        font-medium text-xs border border-white text-white'
      >
       {props.filterCount}
      </span>
     )}
    </Button>
   </div>
  </>
 )
}

KTFilterButton.defaultProps = {
 className: 'w-full',
}

export {KTFilterButton}
